import React from 'react';
import { cn } from '../../utils/cn';

export interface BadgeProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'className'> {
  children: React.ReactNode;
  variant?: 'primary' | 'coral' | 'green' | 'gold' | 'muted' | 'destructive';
  size?: 'sm' | 'md';
  className?: string;
  /** Forwarded to the root `<span>` — useful for test hooks. */
  'data-testid'?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className,
  ...rest
}) => {
  const base = 'inline-flex items-center rounded-full font-medium transition-colors duration-150';

  const sizes: Record<string, string> = {
    sm: 'text-[10px] px-1.5 py-px',
    md: 'text-xs px-2 py-0.5',
  };

  const variants: Record<string, string> = {
    primary:     'bg-[var(--primary-100)] text-[var(--primary-700)]',
    coral:       'bg-[var(--coral-100)] text-[var(--coral-900)]',
    green:       'bg-[var(--green-100)] text-[var(--green-900)]',
    gold:        'bg-[var(--gold-100)] text-[var(--gold-900)]',
    muted:       'bg-[var(--muted)] text-[var(--muted-foreground)]',
    destructive: 'bg-[#fee2e2] text-[var(--destructive)]',
  };

  return (
    <span className={cn(base, sizes[size], variants[variant], className)} {...rest}>
      {children}
    </span>
  );
};

export default Badge;
